import React from 'react'
import {lightGreenA700} from 'material-ui-legacy/styles/colors'
import ContentLink from 'material-ui-legacy/svg-icons/content/link'

import DataGrid from '../UI/DataGrid'
import { ServiceCard } from './ServiceCard'

const ListServices = () => {
  const gridColumns = [
    { name: 'id', title: 'ID' },
    { name: 'projectTypeName', title: 'Project type' },
    { name: 'serviceCategoryName', title: 'Category' },
    { name: 'order', title: 'Order' },
    { name: 'name', title: 'Name' },
    { name: 'description', title: 'Client-facing name' },
    { name: 'formattedCost', title: 'Cost' },
    { name: 'formattedRate', title: 'Rate' }
  ]

  const gridRowMappingFn = service => {
    const id = service.id
    const {
      projectTypeName,
      serviceCategoryName,
      order,
      name,
      description,
      formattedCost,
      formattedRate,
      costFormulaId,
      rateFormulaId
    } = service.attributes

    const linkedIconStyle = {
      display: 'inline-block',
      margin: '0 0 -8px 5px'
    }

    const linkedIcon = (
      <ContentLink style={linkedIconStyle} color={lightGreenA700} />
    )

    const displayCost = (
      costFormulaId
      ? <span>{formattedCost} {linkedIcon}</span>
      : <span>{formattedCost}</span>
    )

    const displayRate = (
      rateFormulaId
      ? <span>{formattedRate} {linkedIcon}</span>
      : <span>{formattedRate}</span>
    )

    return {
      id: id,
      projectTypeName: projectTypeName,
      serviceCategoryName: serviceCategoryName,
      order: Number(order),
      name: name,
      description: description,
      formattedCost: displayCost,
      formattedRate: displayRate
    }
  }

  const gridSorting = [
    { columnName: 'projectTypeName', direction: 'asc' },
    { columnName: 'serviceCategoryName', direction: 'asc' },
    { columnName: 'order', direction: 'asc' }
  ]
  const sortingStateColumnExtensions = [
    { columnName: 'formattedRate', sortingEnabled: false },
    { columnName: 'formattedCost', sortingEnabled: false }
  ]

  const gridHiddenColumns = ['id']
  const tableColumnVisibilityExtensions = [
    { columnName: 'id', togglingEnabled: false }
  ]

  const filteringStateColumnExtensions = [
    { columnName: 'formattedRate', filteringEnabled: false },
    { columnName: 'formattedCost', filteringEnabled: false }
  ]

  const tableColumnExtensions = [
    { columnName: 'projectTypeName', width: 250 },
    { columnName: 'serviceCategoryName', width: 250 },
    { columnName: 'order', align: 'center', width: 65 },
    { columnName: 'formattedRate', align: 'right', width: 250 },
    { columnName: 'formattedCost', align: 'right', width: 250 }
  ]

  return (
    <DataGrid
      resourceAPIEndpoint="services"
      resourceSingularName="service"
      resourcePluralName="services"
      nameAttribute="name"
      clientRootPath="/services"
      gridColumns={gridColumns}
      gridRowMappingFn={gridRowMappingFn}
      gridSorting={gridSorting}
      gridHiddenColumns={gridHiddenColumns}
      tableColumnVisibilityExtensions={tableColumnVisibilityExtensions}
      tableColumnExtensions={tableColumnExtensions}
      filteringStateColumnExtensions={filteringStateColumnExtensions}
      sortingStateColumnExtensions={sortingStateColumnExtensions}
      detailsCard={ServiceCard}
    />
  )
}

export default ListServices



// WEBPACK FOOTER //
// ./src/components/Services/ListServices.jsx